import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ItemMovement {
  id: string;
  itemId: string;
  itemName: string;
  type: 'in' | 'out' | 'adjustment' | 'purchase_receipt';
  quantity: number;
  notes: string | null;
  osId: string | null;
  purchaseOrderId: string | null;
  createdAt: string;
}

export interface ItemPurchase {
  poNumber: number;
  poId: string;
  poStatus: string;
  supplierName: string;
  quantityOrdered: number;
  quantityReceived: number;
  /** Nulo sem estoque.custo. */
  unitPrice: number | null;
  orderedAt: string | null;
  createdAt: string;
}

export function useItemMovements(itemId: string | null) {
  return useQuery<{ movements: ItemMovement[] }>({
    queryKey: ['inventory-movements', itemId],
    queryFn: async () => {
      const res = await api.get(`/inventory/movements?itemId=${itemId}`);
      return res.data;
    },
    enabled: !!itemId,
  });
}

export function useItemPurchases(itemId: string | null) {
  return useQuery<{ purchases: ItemPurchase[] }>({
    queryKey: ['inventory-purchase-history', itemId],
    queryFn: async () => {
      const res = await api.get(`/inventory/${itemId}/purchase-history`);
      return res.data;
    },
    enabled: !!itemId,
  });
}
